import { Box, Grid, Typography, styled, useTheme } from "@mui/material";

import { Activity, Calendar, Time } from "assets/Icon";

function ActivityBox({ activity }) {
  const theme = useTheme();

  return (
    <ActivityCard>
      <Grid container spacing={2} flexDirection="row-reverse">
        <Grid item xs={12}>
          <ItemWrapper>
            <Activity color={theme.palette.secondary.main} />

            <Typography color="text.main" variant="h6">
              {activity?.browser} | {activity?.deviceOsName}
            </Typography>
          </ItemWrapper>
        </Grid>

        <Grid item xs={12}>
          <ItemWrapper>
            <Typography sx={{ marginLeft: 1 }} color="secondary.main">
              IP
            </Typography>
            <Typography color="text.main" variant="h6">
              {activity?.ip}
            </Typography>
          </ItemWrapper>
        </Grid>

        <Grid item xs={12}>
          <ItemWrapper>
            <Typography sx={{ marginLeft: 1 }} color="secondary.main">
              Type
            </Typography>
            <Typography
              color={
                activity?.type === "Succeeded"
                  ? "modules.checked"
                  : "error.main"
              }
              variant="h6"
            >
              {activity?.type}
            </Typography>
          </ItemWrapper>
        </Grid>

        <Grid item xs={6}>
          <ItemWrapper>
            <Calendar color={theme.palette.secondary.main} />
            <Typography color="text.main" variant="h6">
              {activity?.date}
            </Typography>
          </ItemWrapper>
        </Grid>

        <Grid item xs={6}>
          <ItemWrapper>
            <Time color={theme.palette.secondary.main} />
            <Typography color="text.main" variant="h6">
              {activity?.time}
            </Typography>
          </ItemWrapper>
        </Grid>
      </Grid>
    </ActivityCard>
  );
}

const ItemWrapper = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "row-reverse",
}));

const ActivityCard = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  background: theme.palette.background.primaryGradient,
  borderRadius: "8px",
  border: `1px solid ${theme.palette.modules.border}`,
  svg: {
    marginLeft: theme.spacing(1),
  },
}));

export default ActivityBox;
